var _defs, _g, _g2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLogoWhite2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 2158 1080",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .st0 {\n        fill: #fff;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M52.02,216.87h149.46l-.55,145.43,135.16-145.43h164.32l-138.64,147.45,140.66,210.9h-170.92l-75.19-125.44-55.2,52.27.55,73.17H52.2V217.05l-.18-.18Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M515.08,216.87h187.79l33.74,102.88,34.29,103.8,34.29-103.8,33.74-102.88h187.79v358.16h-126.91l.55-179.54.55-46.03-15.4,46.03-61.44,179.54h-111.13l-61.44-179.54-15.4-46.03.55,46.03.55,179.54h-122.32V216.87h.18Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M1058.09,216.87h150.01v358.16h-150.01V216.87Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M1366.55,393.84l-144.33-177.15h165.23l73.72,96.65,73.72-96.65h159.18l-144.33,176.6,148.36,181.74h-166.88l-76.84-101.41-75.74,101.41h-160.1l147.81-181.19h.18Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M1956.7,373.85c-8.25-45.48-38.33-67.49-74.64-67.49-45.48,0-75.19,28.06-75.19,90.04s29.71,90.04,74.64,90.04c37.78,0,68.59-23.47,75.74-71.16h148.91c-9.72,105.45-98.3,168.9-227.77,168.9-136.08,0-227.77-70.05-227.77-188.34s91.69-188.34,227.77-188.34c127.46,0,216.4,62.35,227.77,166.33,0,0-149.46,0-149.46,0Z"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M52.02,778.04h23.84c9.9,50.07,42.36,75.37,98.66,75.37,51.17,0,82.16-20.17,82.16-51.17,0-38.7-50.43-45.66-100.5-55.2-50.43-9.17-100.5-21.27-100.5-69.14,0-39.43,37.23-69.87,101.6-69.87,68.04,0,112.97,33.56,123.6,92.8h-23.11c-9.9-48.23-45.3-74.27-100.5-74.27-48.6,0-78.31,20.91-78.31,48.96,0,35.76,43.83,44.56,90.59,53.37,53.37,10.27,110.4,20.54,110.4,71.34,0,42.73-37.59,71.71-105.27,71.71s-112.23-32.46-122.87-93.9h.18Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M423.02,631.14h-110.03v-19.07h243.36v19.07h-110.03v236.94h-23.47v-236.94h.18Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M588.8,762.08v-149.83h23.47v149.46c0,58.5,37.96,90.59,92.8,90.59s92.8-32.09,92.8-90.59v-149.46h22.74v149.83c0,69.14-47.13,110.03-116.27,110.03s-115.54-41.26-115.54-110.03Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M852.88,612.07h97.93c80.14,0,135.52,46.76,135.52,128.01s-55.57,128.01-135.52,128.01h-97.93v-256.01ZM876.17,631.51v217.5h73.54c67.67,0,112.97-39.06,112.97-108.93s-45.3-108.57-112.97-108.57h-73.54Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M1118.61,612.07h23.11v255.83h-23.11v-255.83Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M1174,740.08c0-84.73,57.4-132.41,131.31-132.41s131.31,47.5,131.31,132.41-57.4,132.41-131.31,132.41-131.31-47.13-131.31-132.41ZM1412.77,740.08c0-70.24-44.93-112.97-107.47-112.97s-107.47,42.73-107.47,112.97,44.93,112.97,107.47,112.97,107.47-42.73,107.47-112.97Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoWhite2);
export default __webpack_public_path__ + "static/media/logo-white_2.b1043255dd62dafa75f25195bb021ebc.svg";
export { ForwardRef as ReactComponent };